/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2023 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import enquire from 'enquire.js';
import React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import CustomGrid, { GridProps } from './Grid';

const mediaQueries = [
  { screen: 'screen and (max-width: 640px)', columns: 2 },
  { screen: 'screen and (min-width: 641px) and (max-width: 767px)', columns: 2 },
  { screen: 'screen and (min-width: 768px) and (max-width: 1023px)', columns: 3 },
  { screen: 'screen and (min-width: 1024px) and (max-width: 1279px)', columns: 4 },
  { screen: 'screen and (min-width: 1280px) and (max-width: 1535px)', columns: 5 },
  { screen: 'screen and (min-width: 1536px)', columns: 5 },
];


export default function makeResponsive(
  Grid: typeof CustomGrid,
): any {
  return class MakeResponsive extends React.PureComponent<GridProps> {

    private ref: any = React.createRef();
    state = {
      columns: 1,
      columnWidth: 200,
      gutterWidth: 14
    }

    handleMediaQuery = num => {
      this.setState({
        ...this.state, columns: num
      })
    }

    resize = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width - (this.state.columns * 10) + 10;
      this.setState({
        ...this.state, columnWidth: Math.round(width / this.state.columns)
      })
    })

    componentDidMount(): void {
      for (let keys of mediaQueries) {
        enquire.register(keys.screen, {
          match: () => {
            this.handleMediaQuery(keys.columns);
          }
        })
      }
      this.resize.observe(this.ref.current);
    }

    render() {
      return <div ref={this.ref} style={{ width: "100%" }}>
        <Grid {...this.props} {...this.state} />
      </div>
    }
  }
};

